import { createToObject } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { Redirect } from 'quartz-routing/react-router';
import { ProductLevel } from 'pricing-pages-ui-components/constants/ProductLevel';
import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
import { useCompanyDetails } from '../hooks/useCompanyDetails';
import { useRecommendedRouting } from '../hooks/useRecommendations';
import { useIsUngatedForSeats } from '../v2/hooks/gating/useIsUngated';
import { useCrmSuiteOwnershipLevel, useIsFreePortal } from '../v2/hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultInAppRoute = () => {
  const {
    recommendedRoute,
    loading: isLoadingRecommendedRoute
  } = useRecommendedRouting();
  const {
    loading: isCompanyDetailsLoading,
    isVSBPortal
  } = useCompanyDetails();
  const {
    isUngatedForSeats,
    loading: isSeatsLoading
  } = useIsUngatedForSeats();
  const {
    crmSuiteLevel: ownedSuiteProductLevel
  } = useCrmSuiteOwnershipLevel();
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isFreeVSBPortal = isVSBPortal && isFreePortal;
  const ownsSuiteProduct = isUngatedForSeats && ownedSuiteProductLevel && ownedSuiteProductLevel !== ProductLevel.FREE;
  if (isLoadingRecommendedRoute || isCompanyDetailsLoading || isInventoryLoading || isSeatsLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  if (isFreeVSBPortal) {
    return /*#__PURE__*/_jsx(Redirect, {
      from: "/",
      exact: true,
      to: createToObject('/crm')
    });
  }
  if (ownsSuiteProduct) {
    return /*#__PURE__*/_jsx(Redirect, {
      from: "/",
      exact: true,
      to: createToObject('/suite')
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    from: "/",
    exact: true,
    to: createToObject(`/${recommendedRoute}`)
  });
};